import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";

import { CalendarOutlined, DownOutlined } from "@ant-design/icons";
import { merchantApi, pumkinAPI } from "@api";
import { ArrowLeftColor, ImageUploadIcon } from "@components";
import { PATH_HOME, _10MB } from "@configs";
import { IUploadReceipt } from "@interfaces";
import liff from "@line/liff";
import { getUploadReceiptSetting, selectApp, selectAuth, selectMerchant, setLoading } from "@redux";
import { formatMessage, useNotify } from "@utils";
import type { DatePickerProps } from "antd";
import { Button, Col, DatePicker, Input, Row, Select, Skeleton } from "antd";
import JIMP from "jimp";
import jsQR from "jsqr";
import { useTranslation } from "react-i18next";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { QrReader as Qr2 } from "react-qr-reader";
import { SendIcon } from "src/Components/icon/Send";
import { useFullScreen } from "src/Helpers/useFullscreen";
import styled from "styled-components";
import { calculateFadeColor } from "../Utils/fadeColor";

//@ts-ignore
const { Option } = Select;
interface IinputValue {
    product?: string;
    purchaseDate?: Date;
    recieptDetail?: string;
    channel?: any;
    store?: any;
    storeValue?: string;
}
export const PageUploadReceiptPunkin = () => {
    //page hook
    const history = useHistory();
    const dispatch = useDispatch();

    const { loading } = useSelector(selectApp);
    const { id } = useParams<{ id: string }>();
    //page redux
    const { userInfo } = useSelector(selectAuth);
    const { themes, memberShipTiers } = useSelector(selectMerchant);
    const themeColor = themes?.themeColor!;
    const merchant = useSelector(selectMerchant);
    const { t } = useTranslation();
    const [receiptImg, setReceiptImg] = useState<any>("");
    const [imgFile, setImgFile] = useState<any>("");
    const { langSetting } = useSelector(selectApp);
    const { success, error, warning } = useNotify();
    const [open, setOpen] = useState<boolean>(false);
    const [opentext, setOpenText] = useState<boolean>(false);
    const [openshowpopup, setOpenShowPopup] = useState<boolean>(true);
    const [tab, setTab] = useState<string>("upload");
    const [sellerCode, setSellerCode] = useState<string>("");
    const [cameraOpen, setCameraOpen] = useState<boolean>(false);
    const [isLine, setIsLine] = useState<boolean>(false);
    const [showImg, setShowImg] = useState<boolean>(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isLoading, setIsloading] = useState(true);
    const [showLoading, setShowLoading] = useState(false);
    const [openExample, setOpenExample] = useState(false);
    const [inputValue, setInputValue] = useState<IinputValue>({});
    const [channelList, setChannelList] = useState<any>([]);
    const [storeList, setStoreList] = useState<any>([]);

    //page state

    const checkScanner = async () => {
        await null;
        let readScanner = sessionStorage.getItem("READ_SCANNER");
        if (readScanner) {
            setSellerCode(readScanner);
            sessionStorage.removeItem("READ_SCANNER");
            // liff.closeWindow();
        }
    };
    const getChannelList = async () => {
        try {
            const res = await pumkinAPI.getChannelList();
            if (res.data) {
                setChannelList(res.data);
            }
        } catch (err) {
            console.log("getChannelList", err);
        }
    };
    const getStoreList = async (value: string) => {
        try {
            const res = await pumkinAPI.getStoreList(value);
            if (res.data[0]?.channelList?.storeList) {
                setStoreList(res.data[0]?.channelList?.storeList);
            }
        } catch (err) {
            console.log("getStoreList", err);
        }
    };

    useEffect(() => {
        checkScanner();
        getChannelList();
        getUploadReceipt();
    }, []);
    const getUploadReceipt = () => {
        // if (!merchant?.uploadReceiptSetting) {
        //     dispatch(getUploadReceiptSetting());
        // }
        dispatch(getUploadReceiptSetting());
    };

    useEffect(() => {
        let queryParams = new URLSearchParams(window.location.search);
        let open = queryParams.get("open" || "");
        if (open === "scan") {
            setTab("scan");
            setOpenShowPopup(false);
        }
        console.log("UE");
        checkBrowser();
    }, []);

    useEffect(() => {
        if (userInfo?.contact?.sellerId) {
            warning("Seller can not upload recript");
            history.push(PATH_HOME);
        }
    }, [userInfo]);

    useEffect(() => {
        setIsloading(true);
        if (merchant) {
            // console.log("merchant", merchant?.uploadReceiptSetting);
            setIsloading(false);
        }
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setInputValue((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    const onChangeDate: DatePickerProps["onChange"] = (dateString) => {
        setInputValue((prevState) => ({
            ...prevState,
            purchaseDate: new Date(dateString.toString()),
        }));
    };
    const onChannelChange = (value: string) => {
        const foundItem = channelList.find((item: any) => item.channelList._id === value);
        setInputValue((prevState) => ({
            ...prevState,
            channel: foundItem.channelList,
            store: "",
            storeValue: "",
        }));
        getStoreList(value);
    };

    const initializeLiff = async () => {
        try {
            const response = await fetch("https://api.line.me/liff/v1/devices/scancodes", {
                method: "POST",
                headers: {
                    Authorization: `Bearer YOUR_LIFF_ACCESS_TOKEN`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ type: "qrcode" }),
            });

            if (response.ok) {
                const result = await response.json();
            } else {
                // การเรียก API ไม่สำเร็จ
                console.error("การสแกน QR Code ไม่สำเร็จ");
            }
        } catch (error) {
            console.error("เกิดข้อผิดพลาดในการเรียกใช้ API:", error);
        }
    };

    const lineQR = async () => {
        try {
            await null;
            // const result = await liff?.scanCdeV2();
            // success(result.value);
        } catch (err: any) {
            warning(typeof err);
        }
    };
    async function getUserProfile() {
        const profile = await liff.getProfile();
        console.log("profile", profile);
        // document.getElementById("pictureUrl").style.display = "block"
        // document.getElementById("pictureUrl").src = profile.pictureUrl
    }
    const isTechDomain = () => {
        const currentURL = window.location.href;
        const regex = /\.app$/i;
        return regex.test(currentURL);
    };
    const checkBrowser = async () => {
        await null;
        const userAgent = navigator.userAgent;
        let lowerText: string = userAgent.toLowerCase();
        if (
            lowerText.includes("line")
            // && lowerText.includes('android')
        ) {
            // from line android
            // await initializeLiff();

            setIsLine(true);
            // alert("in line");
        }
    };

    const previewStyle = {
        height: "100%",
        width: "100%",
    };

    const inputRef = useRef();
    const qrRef = useRef();

    const handleScan = (result: any) => {
        if (result) {
            // setResult(result);
            setSellerCode(result?.data);
            setTab("upload");
        }
    };

    const handleError = (error: any) => {
        console.error(error);
    };

    const changeImg = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files || e.target.files.length === 0) {
            setReceiptImg("");
            return;
        } else {
            const objectUrl = URL.createObjectURL(e.target.files[0]);
            setImgFile(e.target.files[0]);
            setReceiptImg(objectUrl);
        }
    };

    async function findQRCodeInImage(imagePath: string) {
        try {
            const image: JIMP = await JIMP.read(imagePath);
            image.resize(400, JIMP.AUTO);

            const imageData: any = new Uint8Array(image.bitmap.data.buffer);

            const code = jsQR(imageData, image.bitmap.width, image.bitmap.height);

            if (code) {
                return code.data;
            } else {
                return null;
            }
        } catch (error) {
            console.error("Error processing image:", error);
            return null;
        }
    }

    const changeQr = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target?.files?.[0];
        if (file) {
            let imgUrl = URL.createObjectURL(file);
            findQRCodeInImage(imgUrl)
                .then((code) => {
                    if (code) {
                        setSellerCode(code);
                        success("success add seller");
                        setTab("upload");
                    } else {
                        setSellerCode("");
                        warning("No QR code found in the image.");
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });

            // const reader = new FileReader();

            // reader.onload = (event) => {
            //     const image = new Image();
            //     image.src = event?.target?.result as string;
            //     image.onload = () => {
            //         const canvas = document.createElement("canvas");
            //         const context = canvas.getContext('2d');
            //         canvas.width = image.width;
            //         canvas.height = image.height;
            //         context?.drawImage(image, 0, 0);
            //         if (context) {

            //             const imageData = context.getImageData(0, 0, image.width, image.height);
            //             const code = jsQR(imageData.data, image.width, image.height);
            //             if (code) {
            //                 setSellerCode(code?.data);
            //                 success("success add seller");
            //                 setTab("upload");
            //             } else {
            //                 setSellerCode("");
            //                 warning("No QR code found in the image.");
            //             }
            //         }
            //     };
            // };
            // reader.readAsDataURL(file);
        }
    };

    const clickImgQr = () => {
        if (qrRef.current) {
            //@ts-ignore
            qrRef.current.click();
        }
    };

    const uploadImage = async (formData: FormData) => {
        try {
            const res = await merchantApi.uploadImage(formData);
            return res.data.publicUrl;
        } catch (err: any) {
            // const data = err.response.data;
            // const mess = Array.isArray(data.errors) ? data.errors[0] : data.message;
            // console.log("uploadImage", err);
            error(formatMessage(err.response));
        } finally {
            dispatch(setLoading(false));
        }
    };

    const handleConfirm = async () => {
        await null;
        let check = false;
        let mss = "";
        try {
            dispatch(setLoading(true));
            setShowLoading(true);
            // if (isProcessing) {
            //     // If the button is already processing, do nothing
            //     return;
            // }
            // setIsProcessing(true);
            if (
                !inputValue.product &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["product"] &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["product"].isUsed &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["product"]
                    .isDisplayUser &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["product"].isRequired
            ) {
                check = true;
                mss = "product is required";
            } else if (
                !inputValue.purchaseDate &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["purchaseDate"] &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["purchaseDate"].isUsed &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["purchaseDate"]
                    .isDisplayUser &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["purchaseDate"].isRequired
            ) {
                check = true;
                mss = "Purchase date is required";
            } else if (
                !inputValue.recieptDetail &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["recieptDetail"] &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["recieptDetail"]
                    .isDisplayUser &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["recieptDetail"]
                    .isRequired
            ) {
                check = true;
                mss = "Receipt detail is required";
            } else if (
                !inputValue.channel &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["channel"] &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["channel"].isUsed &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["channel"]
                    .isDisplayUser &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["channel"].isRequired
            ) {
                check = true;
                mss = "channel is required";
            } else if (
                !inputValue.store &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["store"] &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["store"].isUsed &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["store"].isDisplayUser &&
                merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["store"].isRequired
            ) {
                check = true;
                mss = "store is required";
            }
            if (receiptImg === "") {
                check = true;
                mss = t("page.upload_receipt.empty_error");
            }
            if (check) {
                warning(mss);
            } else {
                console.log("inputValue", inputValue);
                if (imgFile.size >= _10MB) {
                    error(t("validation.image.max_size"));
                    dispatch(setLoading(false));
                } else {
                    const formData = new FormData();
                    formData.append("file", imgFile);

                    let imgUrl = await uploadImage(formData);

                    if (imgUrl) {
                        let payload: IUploadReceipt = {
                            merchantId: userInfo?.merchantId || "",
                            userId: userInfo?.contact?.userId || "",
                            userName: userInfo?.username || "",
                            userTel: userInfo?.phoneNumber || "",
                            imageUrl: imgUrl,
                            sellerId: sellerCode,
                            ...inputValue,
                        };
                        await merchantApi.uploadReceipt(payload);
                        success(
                            t("page.upload_receipt.success_with_text", {
                                text: merchant?.superAdminTier?.uploadEvidenceDisplay || "",
                            })
                        );
                        history.push(PATH_HOME);
                    }

                    setShowLoading(false);
                }
            }
            console.log("check", check);
        } catch (err: any) {
            // const data = err.response.data;
            // const mess = Array.isArray(data.errors) ? data.errors[0] : data.message;
            error(formatMessage(err.response));
            setShowLoading(false);
            // setIsProcessing(false);
        } finally {
            setShowLoading(false);
            dispatch(setLoading(false));
        }
    };

    const handleLineScan = async () => {
        try {
            const result = await liff.scanCodeV2();
            console.log("Scanned code:", result);
            if (result?.value) {
                setSellerCode(result?.value);
            }

            // alert(result.value);
        } catch (err) {
            console.error(err);
            alert(err);
        }
    };

    const fullHeight = useFullScreen();

    return (
        <StyledReceiptPage
            themeColor={themes?.themeColor!}
            style={{ height: fullHeight }}
            fadeColor={calculateFadeColor(themeColor, 0.08)}
        >
            <input
                //@ts-ignore
                ref={qrRef}
                type="file"
                hidden
                id="uploadQr"
                onChange={changeQr}
                accept="image/png, image/jpeg, image/jpg"
            />

            {tab === "upload" && (
                <>
                    <header>
                        <div className="back-arrow">
                            <ArrowLeftColor
                                color={themes?.themeColor}
                                onClick={() => history.push(PATH_HOME)}
                            />
                            {/* <span>{t("page.back")}</span> */}
                        </div>
                    </header>
                    <div className="step-logo">
                        {/* <div className="step">
                    <p>1</p>
                    <div>&nbsp;</div>
                    <p>2</p>
                </div> */}
                        <Skeleton loading={isLoading} active avatar title={false} paragraph={false}>
                            <div className="logo">
                                <img src={merchant?.themes?.logoSmallUrl} />
                            </div>
                        </Skeleton>
                    </div>
                    <div className="title-receipt">
                        <Skeleton
                            loading={isLoading}
                            active
                            title={{ width: 168 }}
                            paragraph={{ rows: 2, width: [268, 206] }}
                        >
                            <h1>
                                {/* {merchant?.uploadReceiptSetting?.en?.header || t("page.upload_receipt.title")} */}
                                {langSetting?.language === "ENGLISH"
                                    ? merchant?.uploadReceiptSetting?.en?.header ||
                                      t("page.upload_receipt.title")
                                    : merchant?.uploadReceiptSetting?.th?.header ||
                                      t("page.upload_receipt.title")}
                            </h1>
                            {langSetting?.language === "ENGLISH" ? (
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            merchant?.uploadReceiptSetting?.en?.discription || "",
                                    }}
                                ></p>
                            ) : (
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            merchant?.uploadReceiptSetting?.th?.discription || "",
                                    }}
                                ></p>
                            )}
                        </Skeleton>
                    </div>
                    <div className="layout-img-skeleton">
                        <Skeleton
                            loading={isLoading}
                            active
                            title={true}
                            paragraph={{ rows: 1, width: [100] }}
                        >
                            <input
                                //@ts-ignore
                                ref={inputRef}
                                type="file"
                                hidden
                                id="uploadImage"
                                onChange={changeImg}
                                accept="image/png, image/jpeg, image/jpg"
                            />
                            <div className="box-image">
                                {receiptImg === "" ? (
                                    <div className="dont-have-img">
                                        <label className="camera-text" htmlFor="uploadImage">
                                            <ImageUploadIcon color={themes?.themeColor!} />
                                            <p>
                                                + {t("page.upload_receipt.upload_text")}
                                                <span className="color-span">
                                                    {t("page.upload_receipt.receipt")}
                                                </span>
                                            </p>
                                        </label>
                                    </div>
                                ) : (
                                    <div className="have-img">
                                        <label className="camera-text" htmlFor="uploadImage">
                                            <img src={receiptImg} />
                                        </label>
                                    </div>
                                )}
                            </div>
                            <Button
                                className="view-btn-type-2"
                                disabled={sellerCode !== ""}
                                onClick={() => setOpenExample(true)}
                            >
                                {langSetting?.language === "ENGLISH"
                                    ? merchant?.uploadReceiptSetting?.en?.exampleButton ||
                                      t("page.upload_receipt.view_example")
                                    : merchant?.uploadReceiptSetting?.th?.exampleButton ||
                                      t("page.upload_receipt.view_example")}
                            </Button>
                        </Skeleton>
                        {merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["product"] &&
                            merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["product"]
                                .isUsed &&
                            merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["product"]
                                .isDisplayUser && (
                                <div>
                                    <p className="custom-title-input">
                                        {"ชื่อสินค้า"}
                                        {merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.[
                                            "product"
                                        ].isRequired && <span style={{ color: "black" }}> * </span>}
                                    </p>
                                    <Input
                                        placeholder={"กรอกชื่อสินค้า"}
                                        name="product"
                                        onChange={handleChange}
                                        // value={ans.companyName}
                                    />
                                </div>
                            )}
                        {merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.[
                            "purchaseDate"
                        ] &&
                            merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.[
                                "purchaseDate"
                            ].isUsed &&
                            merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.[
                                "purchaseDate"
                            ].isDisplayUser && (
                                <div>
                                    <p className="custom-title-input">
                                        {"วันที่ซื้อสินค้า"}
                                        {merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.[
                                            "purchaseDate"
                                        ].isRequired && <span style={{ color: "black" }}> * </span>}
                                    </p>
                                    <DatePicker
                                        className="date-picker"
                                        suffixIcon={
                                            <CalendarOutlined style={{ color: themeColor }} />
                                        }
                                        name="purchaseDate"
                                        placeholder="เลือกวันที่ซื้อสินค้า"
                                        onChange={onChangeDate}
                                    />
                                </div>
                            )}
                        {merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.[
                            "recieptDetail"
                        ] &&
                            merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.[
                                "recieptDetail"
                            ].isDisplayUser && (
                                <div>
                                    <p className="custom-title-input">
                                        {"ยอดการซื้อ (บาท)"}
                                        {merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.[
                                            "recieptDetail"
                                        ].isRequired && <span style={{ color: "black" }}> * </span>}
                                    </p>
                                    <Input
                                        placeholder={""}
                                        name="recieptDetail"
                                        onChange={handleChange}
                                        // value={ans.companyName}
                                    />
                                </div>
                            )}
                        {merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["channel"] &&
                            merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["channel"]
                                .isUsed &&
                            merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["channel"]
                                .isDisplayUser && (
                                <div>
                                    <p className="custom-title-input">
                                        {"ซื้อจากช่องทางไหน"}
                                        {merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.[
                                            "channel"
                                        ].isRequired && <span style={{ color: "black" }}> * </span>}
                                    </p>
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <Select
                                                placeholder={"เลือกช่องทาง"}
                                                // value={ans.gender}
                                                showSearch
                                                optionFilterProp="children"
                                                onChange={(val: string) => onChannelChange(val)}
                                                className="channel-select"
                                                suffixIcon={
                                                    <DownOutlined style={{ color: themeColor }} />
                                                }
                                            >
                                                {channelList?.map((item: any) => (
                                                    <Option
                                                        value={item.channelList?._id}
                                                        key={item._id}
                                                    >
                                                        {item.channelList?.channelName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        {merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["store"] &&
                            merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["store"]
                                .isUsed &&
                            merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.["store"]
                                .isDisplayUser && (
                                <div>
                                    <p className="custom-title-input">
                                        {"ชื่อห้างสรรสินค้า / ร้านตัวแทนจำหน่าย"}
                                        {merchant?.uploadReceiptSetting?.uploadReceiptCustomForm?.[
                                            "store"
                                        ].isRequired && <span style={{ color: "black" }}> * </span>}
                                    </p>
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <Select
                                                showSearch
                                                optionFilterProp="children"
                                                placeholder={
                                                    "กรอกชื่อห้างสรรสินค้า / ร้านตัวแทนจำหน่าย"
                                                }
                                                value={inputValue.storeValue}
                                                onChange={(val: string) => {
                                                    const foundItem = storeList.find(
                                                        (item: any) => item._id === val
                                                    );
                                                    setInputValue((prevState) => ({
                                                        ...prevState,
                                                        store: foundItem,
                                                        storeValue: val,
                                                    }));
                                                }}
                                                className="channel-select"
                                                suffixIcon={
                                                    <DownOutlined style={{ color: themeColor }} />
                                                }
                                            >
                                                {storeList?.map((item: any) => (
                                                    <Option value={item._id} key={item._id}>
                                                        {item.nameStore}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Col>
                                    </Row>
                                </div>
                            )}

                        <div className="bottom-action">
                            <button
                                className="btn-cancel"
                                onClick={() => history.push(PATH_HOME)}
                                // disabled={isProcessing}
                            >
                                ยกเลิก
                            </button>
                            <button
                                className="btn-confirm"
                                onClick={handleConfirm}
                                // disabled={isProcessing}
                            >
                                ยืนยัน{" "}
                                <span>
                                    <SendIcon />
                                </span>
                            </button>
                        </div>
                        <br />
                        {showLoading ? <StyledLoading /> : null}
                        {open && (
                            <StyledDrawer themeColor={themes?.themeColor!}>
                                <div className="content-layout">
                                    <div className="content">
                                        <div className="text-title">
                                            {langSetting?.language === "ENGLISH"
                                                ? merchant?.uploadReceiptSetting?.en
                                                      ?.exampleButton ||
                                                  t("page.upload_receipt.example")
                                                : merchant?.uploadReceiptSetting?.th
                                                      ?.exampleButton ||
                                                  t("page.upload_receipt.example")}
                                        </div>
                                        <div className="content-info">
                                            <div
                                                className="img-section"
                                                onClick={() => {
                                                    setShowImg(true);
                                                    setOpen(false);
                                                }}
                                            >
                                                <img
                                                    src={
                                                        merchant?.uploadReceiptSetting
                                                            ?.exampleEvidenceImg
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <StyledUsedBtn
                                            className="btn-redeem"
                                            themeColor={themes?.themeColor!}
                                            onClick={() => setOpen(false)}
                                        >
                                            {t("page.close")}
                                        </StyledUsedBtn>
                                    </div>
                                </div>
                            </StyledDrawer>
                        )}
                        {showImg ? (
                            <StyledShowImg themeColor={themes?.themeColor!}>
                                <div className="control-show-img">
                                    <img src={merchant?.uploadReceiptSetting?.exampleEvidenceImg} />
                                </div>
                                <div
                                    className="close-popupinvite"
                                    onClick={() => {
                                        setOpen(true);
                                        setShowImg(false);
                                    }}
                                >
                                    <img src="../images/ic-close-invite.svg" alt="" />
                                </div>
                            </StyledShowImg>
                        ) : null}
                        {opentext && (
                            <StyledDrawer themeColor={themes?.themeColor!}>
                                <div className="content-layout">
                                    <div className="content">
                                        <div className="text-title">
                                            {langSetting?.language === "ENGLISH"
                                                ? merchant?.uploadReceiptSetting?.en.referButton
                                                : merchant?.uploadReceiptSetting?.th.referButton}
                                        </div>
                                        <div className="content-text">
                                            {langSetting?.language === "ENGLISH" ? (
                                                <p
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            merchant?.uploadReceiptSetting?.en
                                                                .referInformationButton || "",
                                                    }}
                                                ></p>
                                            ) : (
                                                <p
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            merchant?.uploadReceiptSetting?.th
                                                                .referInformationButton || "",
                                                    }}
                                                ></p>
                                            )}
                                        </div>
                                        <StyledUsedBtn
                                            className="btn-redeem"
                                            themeColor={themes?.themeColor!}
                                            onClick={() => setOpenText(false)}
                                        >
                                            {t("page.close")}
                                        </StyledUsedBtn>
                                    </div>
                                </div>
                            </StyledDrawer>
                        )}
                        {openshowpopup && (
                            <StyledPopupRedeem>
                                <div className="box-popupconfirm">
                                    <img src={merchant?.uploadReceiptSetting?.popupImg} alt="" />
                                    <div
                                        className="box-close"
                                        onClick={() => setOpenShowPopup(false)}
                                    >
                                        {/* <img src="../images/ic-close-receipt.png" alt="" /> */}
                                        <IoIosCloseCircleOutline
                                            size={30}
                                            color={themes?.themeColor}
                                        />
                                    </div>
                                </div>
                            </StyledPopupRedeem>
                        )}
                    </div>
                </>
            )}
            {tab === "scan" && (
                <>
                    <header>
                        <div className="back-arrow">
                            <ArrowLeftColor
                                color={themes?.themeColor}
                                onClick={() => setTab("upload")}
                            />
                            {/* <span>{t("page.back")}</span> */}
                        </div>
                    </header>
                    {/* <div className="scan-qr">
                        <QrReader
                            delay={100}
                            style={previewStyle}
                            onError={handleError}
                            onScan={handleScan}
                        />
                    </div> */}
                    {!isLine && (
                        <div className="qr2">
                            <Qr2
                                onResult={(result: any, error) => {
                                    if (result?.text) {
                                        setSellerCode(result?.text);
                                        setTab("upload");
                                    }
                                }}
                                constraints={{ facingMode: "environment" }}
                            />
                        </div>
                    )}

                    <br />
                    <br />
                    <br />
                    <Button className="view-btn" onClick={clickImgQr}>
                        <img src="../images/ic-select-image.png" alt="" />
                        {t("page.upload_receipt.select_img")}
                    </Button>
                </>
            )}
            {openExample && (
                <StyledPopupExample themeColor={themes?.themeColor!}>
                    <div className="box-popupconfirm">
                        <div className="textTitle">ดูตัวอย่างใบเสร็จ</div>
                        <div className="textDesc">ตำแหน่งเลขที่ใบเสร็จร้านค้าที่ร่วมกิจกรรม</div>
                        <img
                            src={
                                merchant?.uploadReceiptSetting?.exampleEvidenceImg ||
                                "../images/pumpkinReceipt.jpeg"
                            }
                            alt=""
                        />
                        <button onClick={() => setOpenExample(false)} className="btnClose">
                            Close
                        </button>
                    </div>
                </StyledPopupExample>
            )}
        </StyledReceiptPage>
    );
};

const StyledLoading = styled.div`
    display: flex;
    width: 100%;
    height: 100dvh;
    background-color: rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    background-image: url(../../images/img-loading.gif);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 50px;
`;

const StyledShowImg = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    flex-direction: column;
    .control-show-img {
        img {
            width: 100%;
        }
    }
    .close-popupinvite {
        position: relative;
        margin-top: 30px;
        z-index: 5;
        img {
            width: 32px;
        }
    }
`;

const StyledPopupRedeem = styled.div`
    height: 100vh;
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    left: 0;
    .box-popupconfirm {
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        img {
            width: 100%;
        }
        .box-close {
            position: absolute;
            top: -14px;
            right: -14px;
            img {
                width: 30px;
                height: 30px;
            }
        }
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
    }
    .close {
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
        transform: rotate(0deg);
        transition: 0.6s;
        &:hover {
            transform: rotate(90deg);
        }
    }
    .title {
        display: flex;
        align-items: center;
        .image {
            width: 28px;
            margin-right: 8px;
        }
        .member {
            font-style: normal;
            color: ${(p) => p.theme.colors.color};
        }
    }
`;

const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.theme.colors.card};
    background: ${(p) => p.themeColor};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    height: 48px;
    width: 100%;
    &:active {
        opacity: 0.8;
    }
`;

const StyledReceiptPage = styled.div<{ themeColor: string; fadeColor: string }>`
    // height: 100dvh;
    padding: 20px;
    position: relative;
    background-color: #fff;
    position: relative;
    .layout-img-skeleton {
        .ant-skeleton {
            .ant-skeleton-title {
                height: 250px;
                border-radius: 16px;
                width: 100% !important;
            }
            .ant-skeleton-paragraph {
                li {
                    height: 10px;
                    border-radius: 16px;
                    margin: 0 auto;
                }
            }
        }
        .custom-title-input {
            margin: 12px 0 8px 0;
            color: #000;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
        }
        .date-picker {
            width: 100%;
            height: 45px;
        }
        .channel-select {
            width: 100%;
            border-radius: 15px;
        }
        .btn-skeleton {
            .ant-skeleton {
                .ant-skeleton-paragraph {
                    li {
                        height: 52px;
                        border-radius: 16px;
                        width: 100% !important;
                        margin-bottom: 15px;
                    }
                }
            }
        }
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        display: flex;
        align-items: center;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
    .step-logo {
        display: flex;
        justify-content: center;
        .ant-skeleton {
            .ant-skeleton-header {
                text-align: center;
                padding-right: 0;
                span {
                    width: 105px;
                    height: 105px;
                    margin: 0 auto;
                }
            }
        }
        .step {
            display: flex;
            p {
                margin: none;
                background-color: ${(p) => p.themeColor};
                padding: 2px 10px 4px 10px;
                color: ${(p) => p.theme.colors.white};
                border-radius: 100px;
                font-size: 16px;
            }
            div {
                border-top: 3px solid ${(p) => p.themeColor};
                height: 3px;
                width: 20px;
                margin-top: 14px;
            }
        }
        .logo {
            width: 75px;
            height: 75px;
            border-radius: 100%;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
    .info {
        text-align: right;
        margin-bottom: 5px;
        img {
            width: 18px;
        }
    }
    .seller-input-section {
        input {
            border: 1px solid ${(p) => p.themeColor};
            border-radius: 15px;
            height: 68px !important;
            color: black;
        }
        .ant-input-suffix {
            z-index: 0;
        }
        .input-btn {
            color: #ffffff;
            background-color: ${(p) => p.themeColor};
            border-radius: 12px;
            height: 43px;
        }
    }
    .ex-receipt {
        font-size: 12px;
        color: ${(p) => p.themeColor};
        text-decoration: underline;
        text-align: center;
        margin-bottom: 16px;
    }
    .title-receipt {
        margin-bottom: 16px;
        text-align: center;
        .ant-skeleton {
            .ant-skeleton-content {
                display: flex;
                flex-direction: column;
                align-items: center;
                .ant-skeleton-title {
                    margin-top: 15px;
                    margin-bottom: 12px;
                    height: 10px;
                    border-radius: 16px;
                }
                .ant-skeleton-paragraph {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-top: 15px;
                    li {
                        height: 10px;
                        border-radius: 16px;
                    }
                }
            }
        }
        h1 {
            font-size: 28px;
            font-weight: 500;
            color: #01040d;
            margin: 8px 0;
        }
        p {
            color: #96979c;
            font-size: 16px;
            line-height: 19px;
            font-weight: 400;
        }
    }

    .box-image {
        margin: 15px 0px 16px;
        background-color: ${(p) => p.fadeColor};
        opacity: 0.5;
        border-radius: 20px;
        text-align: center;
        border: 2px dashed ${(p) => p.themeColor};
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px 0;
        min-height: 150px;
        .dont-have-img {
            margin: 40px 20px;
            cursor: pointer;
        }
        svg {
            margin-bottom: 10px;
        }
        .have-img {
            margin: 8px;
            img {
                max-width: 100%;
                max-height: 200px;
                border-radius: 16px;
            }
        }
        .color-span {
            color: ${(p) => p.themeColor};
        }
    }
    .view-btn {
        width: 100%;
        border: 1px solid ${(p) => p.themeColor};
        border-radius: 50px;
        height: 48px;
        color: #fff;
        background-color: ${(p) => p.themeColor};
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            margin-right: 5px;
        }
    }
    .view-btn-type-2 {
        width: 100%;
        border: 1px solid ${(p) => p.themeColor};
        border-radius: 50px;
        height: 48px;
        color: ${(p) => p.themeColor};
        background-color: ${(p) => p.theme.colors.card};
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            margin-right: 5px;
        }
    }
    .input-title {
        margin-bottom: 5px;
        margin-top: 40px;
        color: ${(p) => p.themeColor};
    }
    .input-receipt {
        height: 58px;
        padding-left: 20px;
        border: 1px solid ${(p) => p.themeColor}70;
        border-radius: 10px;
        outline: none;
    }
    .input-receipt:focus {
        outline: none;
        box-shadow: none;
    }
    .scan-qr {
        text-align: center;
        width: calc(100% + 40px);
        margin-left: -20px;
        margin-top: 20px;
        section {
        }
    }

    .btn-section {
        width: 100%;
        position: relative;
        padding: 15px 0;
        .btn {
            width: 100%;
            height: 48px;
            border-radius: 50px;
            font-size: 16px;
            font-weight: 600;
            box-shadow: none;
            span {
                font-weight: 600;
            }
        }
        .back {
            border: 1px solid ${(p) => p.themeColor};
            color: black;
        }
        .confirm {
            border: 1px solid ${(p) => p.themeColor};
            color: white;
            background-color: ${(p) => p.themeColor};
        }
    }
    .example-modal {
        position: fixed;
        bottom: 0px;
        width: 480px;
        max-width: 100vw;
        background-color: pink;
        height: 50vh;
        border-radius: 25px 25px 0 0;
    }
    .bottom-action {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .btn-cancel {
            display: flex;
            width: 109px;
            padding: 14.5px 32px;
            justify-content: center;
            align-items: center;
            gap: 8px;
            flex-shrink: 0;
            border-radius: 14px;
            border: 0.8px solid #231f20;
            background: #fff;
            margin-right: 20px;
            height: 45px;
            font-size: 13px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            color: #000000;
            &:active {
                opacity: 0.8;
            }
        }
        .btn-confirm {
            display: flex;
            padding: 14.5px 32px;
            justify-content: center;
            align-items: center;
            gap: 4px;
            flex: 1 0 0;
            background-color: ${(p) => p.themeColor};
            border-radius: 14px;
            color: #fff;
            height: 45px;
            border: none;
            font-size: 13px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            &:active {
                opacity: 0.8;
            }
        }
    }
`;

const StyledDrawer = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
    }
    .content-layout {
        width: 100%;
        height: auto;
        min-height: 80dvh;
        .content {
            padding: 20px;
            width: 100%;
            height: 80vh;
            padding-bottom: 28px;
            background: ${(p) => p.theme.colors.card};
            position: relative;
            border-radius: 16px 16px 0 0;
            bottom: 0;
            margin: auto;
            text-align: center;
            .close {
                position: absolute;
                top: 20px;
                right: 20px;
                cursor: pointer;
                transform: rotate(0deg);
                transition: 0.6s;
                &:hover {
                    transform: rotate(90deg);
                }
            }
            .text-title {
                font-weight: 600;
                font-size: 24px;
                color: ${(p) => p.themeColor};
            }
            .content-text {
                margin: 16px 0;
                p {
                    font-size: 14px;
                    line-height: 24px;
                    text-align: left;
                }
            }
            .content-info {
                border-radius: 16px;
                padding: 20px;
                .img-section {
                    background-color: ${(p) => p.themeColor}30;
                    height: 40vh;
                    border-radius: 25px;
                    margin-bottom: 30px;
                    img {
                        max-width: 100%;
                        max-height: 35vh;
                        margin-top: 20px;
                    }
                }
            }
        }
    }
`;
const StyledPopupExample = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    left: 0;
    .box-popupconfirm {
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 20px;
        .textTitle {
            color: ${(p) => p.themeColor};
            text-align: center;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
        .textDesc {
            color: var(--Text-3, #96979c);
            text-align: center;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
        }
        .btnClose {
            display: flex;
            height: 45px;
            padding: 14.5px 32px;
            justify-content: center;
            align-items: center;
            gap: 8px;
            align-self: stretch;
            border-radius: 14px;
            background: ${(p) => p.themeColor};
            margin-top: 20px;
            color: #fff;
            border: none;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
        img {
            width: 310px;
            height: 401.294px;
        }
        .box-close {
            position: absolute;
            top: -14px;
            right: -14px;
            img {
                width: 30px;
                height: 30px;
            }
        }
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
    }
    .close {
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
        transform: rotate(0deg);
        transition: 0.6s;
        &:hover {
            transform: rotate(90deg);
        }
    }
    .title {
        display: flex;
        align-items: center;
        .image {
            width: 28px;
            margin-right: 8px;
        }
        .member {
            font-style: normal;
            color: ${(p) => p.theme.colors.color};
        }
    }
`;
